const Ax = (props) => props.children;

export default Ax;